import React, { useState } from 'react';
import usePageTitle from '../../hooks/UsePageTitle';
const sections = [
  {
    id: 'introduction',
    icon: "/images/intro-icon.png",
    title: 'Introduction',
    content: (
      <>
        <div className="privacy-policy-indent-shift"><p><b>Arthgrow Solutions Pvt. Ltd. (“Company”, “we”, “us”, or “our”)</b> is committed to safeguarding the privacy of individuals who visit our website or use our services (<b>“you”, “your”, or “User”</b>). This Privacy Policy outlines how we collect, use, store, disclose, and protect your personal data in compliance with the <b>Digital Personal Data Protection Act, 2023 </b>(“DPDPA”) and other applicable laws of India.</p></div>
        
      </>
    ),
  },
  {
    id: 'Scope',
    icon: "/images/scope.png",
    title: 'Scope',
    content: (
      <>
        <div className="privacy-policy-indent-shift"><p>This Privacy Policy applies to all personal data collected by Arthgrow Solutions Pvt. Ltd. in connection with our services that help connect users to banks, NBFCs, and financial institutions (“Partners”) for the purpose of generating leads and facilitating financial services.</p></div>
        
      </>
    ),
  },

  {
    id: 'info-we-collect',
    icon: '/images/personal-sata.png',
    title: 'Types of Personal Data Collected',
    content: (
      <>
        <div className="privacy-policy-indent-shift"><p>
        We may collect the following categories of <b>personal data</b>, including <b>sensitive personal data</b>, from you:
        </p></div>
        <div className="privacy-policy-indent">
          <ul>
            <li><b>Identity Information:</b> Full name, date of birth, gender</li>
            <li><b>Contact Information:</b> Address, phone number, email address</li>
            <li><b>KYC Information:</b></li>
            <ul>
            <li>Aadhaar number (or masked Aadhaar as per UIDAI guidelines)</li>
            <li>PAN number</li>
            <li>Passport, voter ID, driving license, or any other government-issued ID</li>
            </ul>
            
            <li><b>Financial Information:</b></li>
            <ul>
            <li>Bank account details (account number, IFSC)</li>
            <li>Income details including ITR documents</li>
            </ul>
            <li><b>Employment Information:</b> Salary slips, employer details</li>
            <li><b>Device & Technical Information:</b> IP address, browser type, cookies, and device identifiers</li>
          </ul>
        </div>
        <div className="privacy-policy-indent-shift"><p>
        <b>Note:</b> We collect such data only with your express and informed consent.
        </p></div>
      </>
    ),
  },
  {
    id: 'purpose',
    icon: '/images/purpose.png',
    title: 'Purpose of Collection and Use',
    content: (
      <>
        <div className="privacy-policy-indent-shift"><p>We process your data for the following purposes:</p></div>
        <div className="privacy-policy-indent">
          <ul>
            <li>To evaluate your eligibility for financial products or services. </li>
            <li>To generate and share leads with financial institutions or our registered partners.</li>
            <li>To assist in KYC verification as required by RBI guidelines.</li>
            <li>To match and recommend suitable financial products/services. </li>
            <li>To comply with legal or regulatory requirements.</li>
            <li>For record-keeping and audit purposes.</li>
            <li>For internal analytics to improve service delivery (with anonymised and aggregated data).</li>
          </ul>
        </div>
      </>
    ),
  },
  {
    id: 'legal',
    icon: '/images/legal.png',
    title: 'Legal Basis for Processing',
    content: (
      <>
        <div className="privacy-policy-indent-shift"><p>Your personal data is collected and processed based on the following legal grounds:</p></div>
        <div className="privacy-policy-indent">
          <ul>
            <li>Your <b>explicit consent </b>under Section 5 of the DPDPA.</li>
            <li>For <b>performance of a contract</b> between you and our partner institutions.</li>
            <li>For compliance with <b>legal obligations</b>, such as KYC norms.</li>
            <li>For <b>legitimate interests</b>, such as fraud detection or service improvement, provided your rights are not infringed. </li>
          </ul>
        </div>
      </>
    ),
  },
  {
    id: 'Consent-Management',
    icon: '/images/consent.png',
    title: 'Consent Management',
    content: (
      <>
        <div className="privacy-policy-indent">
          <ul>
            <li>You have the right to <b>grant, review, withdraw, or modify</b> your consent at any time.</li>
            <li>Withdrawal of consent may result in discontinuation of services.</li>
            <li>We provide clear options to provide or deny consent for specific purposes at the time of data collection. </li>
          </ul>
        </div>
      </>
    ),
  },
  {
    id: 'data-sharing',
    icon: '/images/data-sharing.png',
    title: 'Data Sharing and Disclosure',
    content: (
      <>
        <div className="privacy-policy-indent-shift"><p>We may share your personal data only with the following parties and under strict confidentiality obligations:</p></div>
        <div className="privacy-policy-indent">
          <ul>
            <li><b>Partner Banks and Financial Institutions</b> for loan/product eligibility checks.</li>
            <li><b>Authorized service providers</b> (data processors, verification agencies, etc.)</li>
            <li><b>Government authorities</b>, regulators or courts as mandated by law.</li>
            <li><b>Credit Bureaus</b> with your consent, for checking your creditworthiness.</li>
            
          </ul>
        </div>
        <div className="privacy-policy-indent-shift"><p>We do not sell or rent your personal data to any third party.</p></div>
      </>
    ),
  },
  {
    id: 'data-transfer',
    icon: '/images/cross-border.png',
    title: 'Cross-border Data Transfers',
    content: (
      <>
        <div className="privacy-policy-indent-shift"><p>If personal data is transferred outside India (e.g., for cloud hosting or analytics), we ensure:</p></div>
        <div className="privacy-policy-indent">
          <ul>
            <li>Data is transferred to jurisdictions approved by the Government of India, or</li>
            <li>Adequate safeguards (such as standard contractual clauses) are implemented in accordance with the DPDPA.</li>
            </ul>
        </div>
      </>
    ),
  },
  {
    id: 'retention',
    icon: '/images/data.svg',
    title: 'Data Storage and Retention',
    content: (
      <>
        
        <div className="privacy-policy-indent">
          <ul>
            <li>Your personal data will be stored securely on servers located in India or jurisdictions compliant with Indian law. </li>
            <li>We retain data only as long as necessary for the purposes stated or as required under applicable law.</li>
            <li>Upon expiration of the retention period, data will be securely deleted or anonymised.</li>
           
          </ul>
        </div>
        </>
    ),
  },
  {
    id: 'rights',
    icon: '/images/right.svg',
    title: 'Your Rights as a Data Principal',
    content: (
      <>
       <div className="privacy-policy-indent-shift"><p>You have the following rights under the DPDPA:</p></div>
        <div className="privacy-policy-indent">
          <ul>
            <li><b>Right to Access:</b> Know what data we hold about you.</li>
            <li><b>Right to Correction:</b> Request corrections to inaccurate or outdated information.</li>
            <li><b>Right to Erasure:</b> Request deletion of your personal data (subject to legal obligations).</li>
            <li><b>Right to Data Portability:</b> Request transfer of your data to another service provider, where technically feasible.</li>
            <li><b>Right to Grievance Redressal: </b>Lodge complaints with us or the Data Protection Board of India.</li>
          </ul>
        </div>
        <div className="privacy-policy-indent-shift"><p>You may exercise these rights by writing to our <b>Grievance Officer</b> at the contact below.</p></div>
      </>
    ),
  },
  {
    id: 'data-security',
    icon: '/images/data-security.png',
    title: 'Data Security Measures',
    content: (
      <>
        <div className="privacy-policy-indent-shift"><p>We implement industry-standard technical and organisational safeguards including but not limited to:</p></div>
        <div className="privacy-policy-indent">
          <ul>
            <li>Encryption of data in transit and at rest.</li>
            <li>Secure servers and firewalls.</li>
            <li>Role-based access controls</li>
            <li>Regular vulnerability assessments and penetration testing</li>
            <li>Employee confidentiality agreements and training.</li>
          </ul>
        </div>
      </>
    ),
  },
  {
    id: 'grievance',
    icon: '/images/grievance-process-icon.png',
    title: 'Grievance Redressal Mechanism',
    content: (
      <>
        <div className="privacy-policy-indent-shift"><p>For questions, concerns or complaints regarding this Privacy Policy or your personal data, please contact our Grievance Officer:</p></div>
        <div className="privacy-policy-indent-shift">
        <ul className="privacy-policy-list-no-bullet">
        <li><b>Name:</b> Abhishek Ranjan</li>
            <li><b>Phone:</b> <a href="tel:9662267474">9662267474</a></li>
            <li><b>Email:</b> <a href="mailto:hello@growbizh.com">hello@growbizh.com</a></li>
            <li><b>Address: </b>52/A, TITANIUM, OPP. AUDA, GARDEN, PRAHLADNAGAR, Azad Society, Ahmadabad City, Ahmedabad- 380015, Gujarat</li>
            
        </ul>
      </div>
      </>
    ),
  },
  {
    id: 'cookies',
    icon: '/images/cookie.svg',
    title: 'Cookies and Tracking Technologies',
    content: (
      <div className="privacy-policy-indent-shift">
        <ul className="privacy-policy-list-no-bullet">
          <li>We may use cookies and similar technologies to enhance user experience, collect usage statistics, and remember your preferences. You may modify your browser settings to decline cookies; however, this may affect site functionality.</li>
        </ul>
      </div>
    ),
  },
  {
    id: 'policy-updates',
    icon: '/images/policies.svg',
    title: 'Updates to This Policy',
    content: (
      <div className="privacy-policy-indent-shift">
        <ul className="privacy-policy-list-no-bullet">
          <li>We may update this Privacy Policy from time to time. Any material changes will be notified on our website. Your continued use of our services after such changes constitutes your consent to the revised policy.</li>
        </ul>
      </div>
    ),
  },
  {
    id: 'law',
    icon: '/images/governing-law.png',
    title: 'Governing Law and Jurisdiction',
    content: (
      <div className="privacy-policy-indent-shift">
        <ul className="privacy-policy-list-no-bullet">
          <li>This Privacy Policy shall be governed by and construed in accordance with the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts located in Ahmedabad.</li>
        </ul>
      </div>
    ),
  },
];

function isMobile() {
  if (typeof window === 'undefined') return false;
  return window.innerWidth <= 480;
}

const PrivacyPolicyPage = () => {
  usePageTitle("Data Privacy Policy - Snapfunds");
  const [openSection, setOpenSection] = useState(isMobile() ? sections[0].id : null);
  const [mobile, setMobile] = useState(isMobile());
  const [showToc, setShowToc] = useState(false);



  React.useEffect(() => {
    function handleResize() {
      setMobile(isMobile());
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <section className="privacy-policy-hero">
        <div className="privacy-policy-hero-content">
          <h1>Privacy Policy</h1>
          <p>At Snapfunds, your privacy is important to us. This Privacy Policy explains how we collect, use, store, and protect your personal information when you visit our website <a href="https://www.snapfunds.in" target="_blank" rel="noopener noreferrer">www.snapfunds.in</a> or use our services.</p>
        </div>
      </section>
      <section className="privacy-policy-main">
        {mobile ? (
          <div className="privacy-policy-accordion">
            <div className="privacy-policy-toc">
              <span>
                <h3>Table of Contents</h3>
              </span>
              <span>
                <img 
                  src="/images/Arrow.svg" 
                  alt="Arrow" 
                  style={{
                    width: '19px', 
                    height: '19px',
                    transform: showToc ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s ease',
                    cursor: 'pointer'
                  }}
                  onClick={() => setShowToc(!showToc)}
                />
              </span>
            </div>
            {showToc && (
              <div className="privacy-policy-mobile-toc">
                {sections.map((section) => (
                  <div 
                    key={section.id}
                    onClick={() => {
                      setOpenSection(section.id);
                      setShowToc(false);
                    }}
                    style={{
                      padding: '12px 20px',
                      borderBottom: '1px solid #e6eaf3',
                      cursor: 'pointer'
                    }}
                  >
                    {section.title}
                  </div>
                ))}
              </div>
            )}
            {sections.map((section) => (
              <div className="privacy-policy-accordion-section" key={section.id}>
                <button
                  className="privacy-policy-accordion-title"
                  aria-expanded={openSection === section.id}
                  aria-controls={`section-content-${section.id}`}
                  onClick={() => setOpenSection(openSection === section.id ? null : section.id)}
                  style={{display: 'flex', alignItems: 'center', width: '100%', background: 'none', border: 'none', padding: '16px 0', fontWeight: 600, fontSize: '1.08rem', cursor: 'pointer'}}
                >
                  <img src={section.icon} alt="" className="icon-svg" style={{marginLeft: 0, marginRight: 12}} />
                  <span style={{flex: 1, textAlign: 'left'}}>{section.title}</span>
                  <img
                    src={openSection === section.id ? '/images/arrow-up.svg' : '/images/arrow-down.svg'}
                    alt={openSection === section.id ? 'Collapse' : 'Expand'}
                    className="privacy-policy-accordion-arrow"
                    style={{width: 24, height: 24, marginLeft: 8}}
                  />
                </button>
                {openSection === section.id && (
                  <div
                    className="privacy-policy-accordion-content"
                    id={`section-content-${section.id}`}
                    style={{padding: '0 8px 12px 8px'}}
                  >
                    {section.content}
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="privacy-policy-container">
            <aside className="privacy-policy-toc">
              <h3>Table of Contents</h3>
              <ol>
                {sections.map((section) => (
                  <li key={section.id}>
                    <a href={`#${section.id}`}>{section.title}</a>
                  </li>
                ))}
              </ol>
            </aside>
            <div className="privacy-policy-content">
              {sections.map((section) => (
                <section id={section.id} className="privacy-policy-section" key={section.id}>
                  <h2><span className={`icon ${section.id}-icon`}><img src={section.icon} alt="" className="icon-svg" /></span> {section.title}</h2>
                  {section.content}
                </section>
              ))}
              <div className="privacy-policy-footer">
              <p><b>Effective Date:</b> 13th August 2025</p>
              <p><b>Last Updated:</b> 13th August 2025</p>
            </div>
            </div>
          </div>
        )}

      </section>
    </>
  );
};

export default PrivacyPolicyPage;